import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export const usePlans = () =>
    useQuery({
        queryKey: ["plans"],
        queryFn: () => axios.get("/api/plans").then(res => res.data)
    });
